import React, { useState } from 'react';
import { Table } from 'react-bootstrap';

import { Button, FormInput, FormInputValueTypes, IBlockContent } from '@praktio/common-ui';
import { WeDontShareYourScoresBody } from '../../../utils/constants';
import { generateCLEString } from '../../../utils/functions';

export const Blocks = ({
  blocks,
  onUpdateBlock,
  course,
}: {
  blocks?: IBlock[];
  onUpdateBlock?: ({
    fieldName,
    value,
  }: {
    fieldName?: string;
    value?: FormInputValueTypes | IBlockContent;
  }) => void;
  course?: ICourse;
}) => {
  const [label, setLabel] = useState('');
  const [content, setContent] = useState('');
  const [editing, setEditing] = useState({} as { [key: string]: boolean });
  const { cleCredits } = course || {};

  return (
    <div className="Blocks d-flex">
      <Table className="BlocksTable PraktioTable">
        <thead>
          <tr>
            <th>Title</th>
            <th>Description</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {/* Share scores - always here */}
          <tr className="PraktioTable-row disabled">
            <td>We don't share you scores</td>
            <td>{WeDontShareYourScoresBody}</td>
            <td className="color-onyx">
              <FormInput
                className="d-flex justify-content-center"
                type="switch"
                largeSwitch
                fieldName="hideScoreBlock"
                value={!course?.hideScoreBlock}
                label={course?.hideScoreBlock ? 'Off' : 'On'}
                onChange={() => {
                  if (onUpdateBlock) {
                    onUpdateBlock({ fieldName: 'hideScoreBlock', value: !course?.hideScoreBlock });
                  }
                }}
              />
            </td>
          </tr>
          {/* CLE Info - always here */}
          <tr className="PraktioTable-row disabled">
            <td>CLE</td>
            <td>
              {cleCredits && cleCredits.length > 0
                ? generateCLEString(cleCredits, course?.authoredBy)
                : 'Not currently available.'}
            </td>
          </tr>

          {/* Dynamic Blocks */}
          {blocks?.map((block, index) => {
            return (
              <tr key={`block-${index}`}>
                {/* Title */}
                <td>{block.label}</td>

                {/* Description */}
                <td>
                  {/* If editing, show the text field for this row. */}
                  {/* If not editing, display the content. */}
                  {editing[block.label] ? (
                    <FormInput
                      fieldName="editBlockDescription"
                      value={block.content || ''}
                      noLabel
                      className="mb-0"
                      onChange={(e: any) => {
                        const value = e.target.value;
                        if (onUpdateBlock) {
                          onUpdateBlock({
                            fieldName: 'blocks',
                            value: { label: block.label, content: value },
                          });
                        }
                      }}
                      onBlur={() => {
                        setEditing({ ...editing, [block.label]: false });
                      }}
                    />
                  ) : (
                    block.content
                  )}
                </td>

                {/* Tools */}
                <td>
                  <div className="PraktioTable-edit-tools d-flex">
                    {!editing[block.label] && (
                      <Button
                        unstyledIcon
                        noStyling
                        onClick={() => setEditing({ ...editing, [block.label]: true })}
                      >
                        edit
                      </Button>
                    )}
                    <Button
                      unstyledIcon
                      noStyling
                      onClick={() => {
                        // onUpdateBlock(row.label, undefined)}
                        if (onUpdateBlock) {
                          onUpdateBlock({
                            fieldName: 'blocks',
                            value: { label: block.label, content: undefined },
                          });
                        }
                      }}
                    >
                      delete
                    </Button>
                  </div>
                </td>
              </tr>
            );
          })}

          {/* Add Block Row - Always Here */}
          <tr>
            <td>
              <FormInput
                fieldName="newBlockTitle"
                value={label}
                className="mb-0"
                onChange={(e: any) => setLabel(e.target.value)}
                noLabel
              />
            </td>
            <td>
              <FormInput
                fieldName="newBlockDescription"
                value={content}
                className="mb-0"
                onChange={(e: any) => setContent(e.target.value)}
                noLabel
              />
            </td>
            <td>
              <div className="d-flex justify-content-center">
                <Button
                  onClick={() => {
                    if (label !== '' && content && content !== '') {
                      if (onUpdateBlock) {
                        onUpdateBlock({
                          fieldName: 'blocks',
                          value: { label: label, content: content },
                        });
                        setLabel('');
                        setContent('');
                      }
                    }
                  }}
                  className="secondary"
                >
                  Add
                </Button>
              </div>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};
